import type { RefOrGetter } from "ls/common/types";
import type { ShortcutJs } from "@/generated/models";
import { defineStore } from "pinia";
import { computed, ref, toValue } from "vue";
import { jsDateFromAspDateString } from "@/common/lib/date";

const useLastModifiedStore = defineStore("lastModifiedDate", () => {
  const shortcutToDate = ref(new Map<string, number>());
  return {
    shortcutToDate,
  };
});

export function useLastModifiedDate(file: RefOrGetter<ShortcutJs>) {
  const store = useLastModifiedStore();

  const lastModifiedDate = computed(() => {
    const fileValue = toValue(file);
    const storeValue = store.shortcutToDate.get(fileValue.Shortcut);
    if (storeValue) {
      return storeValue;
    }
    if (fileValue.ModifiedOn) {
      return jsDateFromAspDateString(fileValue.ModifiedOn).getTime();
    }
    return jsDateFromAspDateString(fileValue.CreatedOn).getTime();
  });

  function update() {
    updateLastModifiedDate(toValue(file).Shortcut);
  }

  const wasModified = computed(() => {
    return lastModifiedDate.value > jsDateFromAspDateString(toValue(file).CreatedOn).getTime();
  });

  return {
    lastModifiedDate,
    wasModified,
    update,
  };
}

export function updateLastModifiedDate(shortcut: string) {
  const store = useLastModifiedStore();
  store.shortcutToDate.set(shortcut, new Date().getTime());
}
